const commonConfig = {
	didKey: btoa(
		"Y3JlYXRpdmVwcm9kdWN0QGZvcmVzdC1pbnRlcmFjdGl2ZS5jb20:gIkWcbXTgwbwfFxClkYhQ"
	),
	timeout: 1000,
};

const environments = {
	production: {
		...commonConfig,
		urls: {
			apiBaseUrl: "",
			feBaseUrl: "",
		},
	},
	staging: {
		...commonConfig,
		urls: {
			apiBaseUrl: "https://jarvis-v2.lawaweb.com/",
			feBaseUrl: "https://aicompanionship.lawaweb.com/",
		},
	},
};

const config = environments.staging;

export default config;
